const MutationObserver = window.MutationObserver || window.WebKitMutationObserver
import { createAnalyticsGroup } from 'js/lib/analytics'
import { registerFunctionalComponent } from 'js/lib/components/component'

const updateButtonState = (button) => {
  const iconBefore = button.querySelector('.js-c-ui-button__icon--before')
  const iconLoading = button.querySelector('.js-c-ui-button__icon--loading')

  if (!iconLoading) return

  const isLoading = button.getAttribute('data-loading') === 'true'

  if (isLoading) {
    if (iconBefore) iconBefore.classList.add('tw-hidden')
    iconLoading.classList.remove('tw-hidden')
    button.classList.add('tw-opacity-70', 'tw-cursor-wait')
    button.setAttribute('disabled', 'true')
  } else {
    if (iconBefore) iconBefore.classList.remove('tw-hidden')
    iconLoading.classList.add('tw-hidden')
    button.classList.remove('tw-opacity-70', 'tw-cursor-wait')
    button.removeAttribute('disabled')
  }
}

const setupObserver = (button) => {
  if (button.observer) return 
  
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'data-loading') {
        updateButtonState(button)

        if (button.getAttribute('data-loading') === 'false') {
          observer.disconnect()
          button.observer = null 
        }
      }
    })
  })

  observer.observe(button, { attributes: true })
  button.observer = observer 
}

// Register general button functionality
registerFunctionalComponent('.js-c-ui-button', 'UiButtonComponent', (component) => {
  const handleClick = (event) => {
    const button = event.currentTarget
    if (button.getAttribute('data-loading') === 'true') {
      updateButtonState(button)
      setupObserver(button)
    }
  }

  component.useHandler(() => {
    component.element.addEventListener('click', handleClick)
    return () => component.element.removeEventListener('click', handleClick)
  })
})

// Register tracking functionality for buttons with tracking attributes
registerFunctionalComponent('.js-c-ui-button-tracking', 'UiButtonTrackingComponent', (component) => {
  const trackingGroup = component.element.getAttribute('data-tracking-group')
  const trackingLabel = component.element.getAttribute('data-tracking-label')
  
  if (trackingGroup && trackingLabel) {
    const track = createAnalyticsGroup(trackingGroup)
    const currentPage = window.location.href
    
    component.useHandler(() => {
      const handleTrackingClick = () => {
        track('click', `${trackingLabel} from ${currentPage}`)
      }
      
      component.element.addEventListener('click', handleTrackingClick)
      return () => component.element.removeEventListener('click', handleTrackingClick)
    })
  }
})
